import ConfirmPublish from './ConfirmPublish'
import PickEditor from './PickEditor'

const Modals = () => {
  return (
    <>
      <ConfirmPublish />
      <PickEditor />
    </>
  )
}

export default Modals
